import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "relative block"
}
const _hoisted_4 = { class: "block invisible" }
const _hoisted_5 = { class: "absolute inset-0" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["id"]
const _hoisted_8 = ["id", "aria-describedby", "value", "size", "inputmode", "type", "min", "disabled"]
const _hoisted_9 = {
  key: 0,
  class: "invisible whitespace-pre h-0 ml-3 mr-4"
}
const _hoisted_10 = ["id"]

import { ulid } from 'ulid'
import { computed, nextTick, onMounted, ref } from 'vue'

export default /*@__PURE__*/Object.assign({
  inheritAttrs: false
}, {
  __name: 'InputField',
  props: [
  'modelValue',
  'type',
  'description',
  // Helper text under the label instead of under the input. Accepts the bare attribute (description-above) or a boolean.
  'descriptionAbove',
  'name',
  'namePlaceholder',
  'prefix',
  'suffix',
  'shrinkwrap',
  'autofocus',
  'class',
  'restrict',
  'disabled',
  'error'
],
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const id = ulid()



const props = __props
const emit = __emit
const el = ref(null)
const focused = ref(false)
// Array-style props hand a bare attribute over as '', so treat anything other than undefined/false as on.
const descriptionAbove = computed(
  () => !!props.description && props.descriptionAbove !== undefined && props.descriptionAbove !== false
)

const onInput = e => {
  const originalValue = e.target.value
  if (props.restrict === 'integer') e.target.value = e.target.value.replace(/\D/g, '')
  if (props.restrict === 'float') e.target.value = e.target.value.replace(/[^0-9.]/g, '').replace(/(?<=\..*)\./g, '')
  if (props.restrict === 'monetary')
    e.target.value = e.target.value
      .replace(/[^0-9.]/g, '')
      .replace(/(?<=\..*)\./g, '')
      .replace(/(\.\d{2})\d+/, '$1')
  if (e.target.value === originalValue) {
    emit('update:modelValue', e.target.value)
  } else {
    e.stopPropagation()
  }
}

onMounted(() => {
  if (props.autofocus) nextTick(() => el.value.focus())
})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-col justify-between", [props.class, props.disabled && 'opacity-50 cursor-not-allowed']])
  }, [
    (props.name || descriptionAbove.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (props.name)
            ? (_openBlock(), _createElementBlock("label", {
                key: 0,
                for: _unref(id),
                class: _normalizeClass(["block text-sm font-medium text-gray-700 mb-1", props.disabled && 'cursor-not-allowed'])
              }, [
                (props.namePlaceholder)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                      _createElementVNode("span", _hoisted_4, _toDisplayString(props.namePlaceholder), 1),
                      _createElementVNode("span", _hoisted_5, _toDisplayString(props.name), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(props.name), 1))
              ], 10, _hoisted_2))
            : _createCommentVNode("", true),
          (descriptionAbove.value)
            ? (_openBlock(), _createElementBlock("p", {
                key: 1,
                id: _unref(id) + '-description',
                class: "mb-2 text-sm text-gray-500"
              }, _toDisplayString(props.description), 9, _hoisted_7))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["flex rounded-md", focused.value && 'ring-1 ring-brand-500 border-brand-500'])
    }, [
      (props.prefix)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["px-3 inline-flex items-center rounded-l-md border border-r-0 bg-gray-50 text-gray-500 sm:text-sm", focused.value ? 'border-brand-500' : 'border-gray-300'])
          }, _toDisplayString(props.prefix), 3))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(!props.shrinkwrap && 'w-full')
      }, [
        _createElementVNode("input", _mergeProps(_ctx.$attrs, {
          id: _unref(id),
          ref_key: "el",
          ref: el,
          class: ["inline w-full sm:text-sm min-w-0 placeholder:text-gray-400 focus:ring-0", [
            !props.prefix && 'rounded-l-md',
            !props.suffix && 'rounded-r-md',
            props.disabled && 'bg-gray-100 cursor-not-allowed',
            props.error ? 'border-red-500 focus:border-red-500' : 'border-gray-300 focus:border-brand-500'
          ]],
          "aria-describedby": _unref(id) + '-description',
          value: props.modelValue,
          size: props.shrinkwrap && 3,
          inputmode: { integer: 'numeric', float: 'decimal', monetary: 'decimal' }[props.restrict],
          type: props.restrict === 'integer' ? 'number' : props.type ?? 'text',
          min: props.restrict === 'integer' ? 0 : undefined,
          disabled: props.disabled,
          onInput: onInput,
          onFocus: _cache[0] || (_cache[0] = $event => (focused.value = true)),
          onBlur: _cache[1] || (_cache[1] = $event => (focused.value = false))
        }), null, 16, _hoisted_8),
        (__props.shrinkwrap)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(__props.modelValue), 1))
          : _createCommentVNode("", true)
      ], 2),
      (props.suffix)
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: _normalizeClass(["px-3 inline-flex items-center whitespace-nowrap rounded-r-md border border-l-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm", focused.value ? 'border-brand-500' : 'border-gray-300'])
          }, _toDisplayString(props.suffix), 3))
        : _createCommentVNode("", true)
    ], 2),
    (props.description && !descriptionAbove.value)
      ? (_openBlock(), _createElementBlock("p", {
          key: 1,
          id: _unref(id) + '-description',
          class: "mt-2 text-sm text-gray-500"
        }, _toDisplayString(props.description), 9, _hoisted_10))
      : _createCommentVNode("", true)
  ], 2))
}
}

})